'use client';

import { useState } from 'react';
import { InputV2, type InputV2Props } from '@/app/_components/ui/InputV2';
import { Icon } from '@/app_components/common/Icon';

interface PasswordInputV2Props extends InputV2Props {}

export const PasswordInputV2 = ({ ...props }: PasswordInputV2Props) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <InputV2
      {...props}
      icon={{
        ariaLabel: showPassword ? 'Hide password' : 'Show password',
        element: (
          <Icon
            icon={showPassword ? 'FormHidePassword' : 'FormShowPassword'}
            size='sm'
            strokeWidth={1.25}
          />
        ),
        onClick: () => setShowPassword(!showPassword),
      }}
      type={showPassword ? 'text' : 'password'}
    />
  );
};
